import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <main style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #0a1628, #1a3c5e)',
      color: '#fff',
      textAlign: 'center',
      padding: '2rem'
    }}>
      <div style={{ fontSize: '6rem', fontWeight: 900, color: '#4a90d9', lineHeight: 1 }}>404</div>
      <h1 style={{ fontSize: '1.8rem', fontWeight: 800, margin: '1rem 0 0.5rem' }}>Page Not Found</h1>
      <p style={{ color: 'rgba(255,255,255,0.55)', marginBottom: '2rem', maxWidth: '400px' }}>
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Link to="/" style={{
        padding: '12px 32px',
        background: 'linear-gradient(135deg, #1a3c5e, #4a90d9)',
        color: '#fff',
        borderRadius: '100px',
        textDecoration: 'none',
        fontWeight: 700,
        fontSize: '15px',
        boxShadow: '0 6px 24px rgba(74,144,217,0.4)'
      }}>
        ← Back to Home
      </Link>
    </main>
  );
}